import request from "./base_requests";

const base_url = process.env.VUE_APP_API + '/dashboard-integration';

export default {
    get_plans(data) {
        return request.get(base_url + '/plans', data)
    },
    get_ticket_topics() {
        return request.get(base_url + '/ticket_topics')
    },
    create_ticket(data) {
        return request.post_file(base_url + '/ticket/create', data)
    },
    create_ticket_message(data) {
        return request.post(base_url + '/tickets/messages/create', data)
    },
    create_feedback(data) {
        return request.post(base_url + '/feedback/create', data)
    }
}
